import Form from './Form.vue'
import List from './List.vue'

const routes = [{
  path: '/users/create',
  component: Form,
  name: 'user/create',
  meta: { roles: ['admin'] }
}, {
  path: '/users/list',
  component: List,
  name: 'user/list',
  meta: { roles: ['admin'] }
}, {
  path: '/users/:userId',
  component: Form,
  name: 'user',
  meta: { roles: ['admin'] }
}]

export default routes